export default __webpack_public_path__ + "static/media/mail_dark.3a61945a.svg";